export default {
  5001: '管理者にご連絡ください',
  5002: '管理者にご連絡ください',
  5005: 'カラム「id」をデータに追加してください'
}



// WEBPACK FOOTER //
// ./src/properties/errorMessage.js